import { render, staticRenderFns } from "./right-tool.vue?vue&type=template&id=44da5b88&scoped=true"
import script from "./right-tool.vue?vue&type=script&lang=js"
export * from "./right-tool.vue?vue&type=script&lang=js"
import style0 from "./right-tool.vue?vue&type=style&index=0&id=44da5b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da5b88",
  null
  
)

export default component.exports